import "../Homepage/Homepage.css";
import ApplicationsList from "../ApplicationsList/ApplicationsList";

export default function Homepage() {
  return (
    <div className="Homepage">
      <ApplicationsList />
    </div>
  );
}
